"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import { useQuery } from "@tanstack/react-query";
import type { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
import { distributionPlanApiFetch } from "@/services/distribution-plan-api";
import { AnimatePresence, motion } from "framer-motion";
import EmmaListSearchItemsContent from "./EmmaListSearchItemsContent";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function EmmaListSearchItems(t0) {
  const $ = _c(21);
  const {
    open,
    searchCriteria,
    selectedId,
    onSelect
  } = t0;
  const {
    connectedProfile,
    requestAuth
  } = useContext(AuthContext);
  const t1 = connectedProfile?.handle;
  let t2;
  if ($[0] !== t1) {
    t2 = [QueryKey.EMMA_IDENTITY_ALLOWLISTS, {
      identity: t1
    }];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== requestAuth) {
    t3 = async () => {
      const {
        success
      } = await requestAuth();
      if (!success) {
        return [];
      }
      const response = await distributionPlanApiFetch("/allowlists");
      return response.data ?? [];
    };
    $[2] = requestAuth;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = !!connectedProfile?.handle && open;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    data,
    isFetching
  } = useQuery(t5);
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const [items, setItems] = useState(t6);
  let t7;
  let t8;
  if ($[9] !== data || $[10] !== searchCriteria) {
    t7 = () => {
      if (!data?.length) {
        setItems([]);
        return;
      }
      if (!searchCriteria) {
        setItems(data);
        return;
      }
      const search = searchCriteria.toLowerCase();
      setItems(data.filter(item => item.name.toLowerCase().includes(search)));
    };
    t8 = [data, searchCriteria];
    $[9] = data;
    $[10] = searchCriteria;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  let t9;
  if ($[13] !== isFetching || $[14] !== items || $[15] !== onSelect || $[16] !== open || $[17] !== selectedId) {
    t9 = open && <motion.div className="tw-absolute tw-z-10 tw-mt-1 tw-w-full tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className="tw-absolute tw-z-10 tw-mt-1 tw-overflow-hidden tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-overflow-x-hidden tw-overflow-y-auto"><ul className="tw-flex tw-flex-col tw-gap-y-1 tw-px-2 tw-mx-0 tw-mb-0 tw-list-none"><EmmaListSearchItemsContent selectedId={selectedId} loading={isFetching} items={items} onSelect={onSelect} /></ul></div></div></motion.div>;
    $[13] = isFetching;
    $[14] = items;
    $[15] = onSelect;
    $[16] = open;
    $[17] = selectedId;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <AnimatePresence mode="wait" initial={false}>{t9}</AnimatePresence>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}